module.exports = __webpack_public_path__ + "static/media/agenda-01.f2aaf6ec.jpg";